import {
    CREATE_WORKER_ATTENDANCE_MONTHLY,
    DELETE_WORKER_ATTENDANCE_MONTHLY,
    GET_WORKER_ATTENDANCE_MONTHLY,
    WORKER_ATTENDANCE_MONTHLY_REQUEST,
    WORKER_ATTENDANCE_MONTHLY_REQUEST_FAILURE,
    UPDATE_WORKER_ATTENDANCE_MONTHLY
  } from "../types/worker-attendance-monthly-types";
  
  const initialState = {
    workerAttendanceMonthly: [],
    loading: false,
    error: null,
  };
  
  const workerAttendanceMonthlyReducer = (state = initialState, action) => {
    switch (action.type) {
      case WORKER_ATTENDANCE_MONTHLY_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        }
      }
      case GET_WORKER_ATTENDANCE_MONTHLY: {
        return {
          ...state,
          workerAttendanceMonthly: [...action.payload],
          loading: false,
          error: null
        }
      }
      case CREATE_WORKER_ATTENDANCE_MONTHLY:
        return {
          ...state,
          workerAttendanceMonthly: [action.payload, ...state.workerAttendanceMonthly],
          loading: false,
          error: null
        };
      case UPDATE_WORKER_ATTENDANCE_MONTHLY:
        const workerAttendanceMonthlyData = state.workerAttendanceMonthly.slice(0);
        console.log('before>>', workerAttendanceMonthlyData);
        const uIndex = workerAttendanceMonthlyData.findIndex((data) => data.id === action.payload.id);
        console.log('uIndex>>', uIndex);
        workerAttendanceMonthlyData.splice(uIndex, 1, { ...action.payload.data });
        console.log('after>>', workerAttendanceMonthlyData.splice(uIndex, 1, { ...action.payload.data }));
        
        return {
          ...state,
          workerAttendanceMonthly: [ ...workerAttendanceMonthlyData ],
          loading: false,
          error: null
        };
      case DELETE_WORKER_ATTENDANCE_MONTHLY:
        const workerAttendanceMonthly = state.workerAttendanceMonthly?.slice(0);
        const index = workerAttendanceMonthly.findIndex((data) => data.id === action.id);
        if (index > -1) {
          workerAttendanceMonthly.splice(index, 1);
        }
        return {
          ...state,
          workerAttendanceMonthly: [...workerAttendanceMonthly],
          loading: false,
          error: null
        }
      case WORKER_ATTENDANCE_MONTHLY_REQUEST_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        }
      }
      default:
        return state;
    }
  };
  
  export default workerAttendanceMonthlyReducer;
  